<template>
  <div>
    <div id="popover-reactive-1" @click="handleButtonClick">
      <b-img
        v-if="ionaActive"
        v-bind="mainPropsTopBar"
        rounded="circle"
        src="@/assets/heartbeat/img/heartbeat_on.png"
        alt="HeartBeats"
      />
      <b-img
        v-else
        v-bind="mainPropsTopBar"
        rounded="circle"
        src="@/assets/iona/img/iona_off.png"
        alt="IONA (Insightful Omnipresent Nurturing Ant) InActive"
      />
    </div>
  </div>
</template>

<script>
import toggleSingle from "@/components/common/toggleSingle";
export default {
  name: "notifications-menu",
  components: {
    toggleSingle
  },
  computed: {},
  methods: {
    handleToggleActive() {
      this.ionaActive = !this.ionaActive;
    },
    handleButtonClick() {
      this.$emit("button-click");
    },
    onClose() {},
    onOk() {
      if (!this.input1) {
        this.input1state = false;
      }
      if (!this.input2) {
        this.input2state = false;
      }
      if (this.input1 && this.input2) {
        this.onClose();
        // Return our popover form results
        this.input1Return = this.input1;
        this.input2Return = this.input2;
      }
    },
    onShow() {
      // This is called just before the popover is shown
      // Reset our popover form variables
      this.input1 = "";
      this.input2 = "";
      this.input1state = null;
      this.input2state = null;
      this.input1Return = "";
      this.input2Return = "";
    },
    onShown() {
      // Called just after the popover has been shown
      // Transfer focus to the first input
      this.focusRef(this.$refs.input1);
    },
    onHidden() {
      // Called just after the popover has finished hiding
      // Bring focus back to the button
      this.focusRef(this.$refs.button);
    },
    focusRef(ref) {
      // Some references may be a component, functional component, or plain element
      // This handles that check before focusing, assuming a `focus()` method exists
      // We do this in a double `$nextTick()` to ensure components have
      // updated & popover positioned first
      this.$nextTick(() => {
        this.$nextTick(() => {
          (ref.$el || ref).focus();
        });
      });
    }
  },
  watch: {
    input1(val) {
      if (val) {
        this.input1state = true;
      }
    },
    input2(val) {
      if (val) {
        this.input2state = true;
      }
    }
  },
  mounted() {},
  data() {
    return {
      ionaActive: true,
      input1: "",
      input1state: null,
      input2: "",
      input2state: null,
      options: [{ text: "- Choose 1 -", value: "" }, "Red", "Green", "Blue"],
      input1Return: "",
      input2Return: "",
      mainPropsTopBar: {
        blank: false,
        blankColor: "#fcc727",
        width: 25,
        height: 25,
        class: "m1"
      },
      form: {}
    };
  }
};
</script>
<style lang="scss" scoped></style>
